import { Image } from '@msdyn365-commerce/core';
import * as React from 'react';
import { ICipImageViewProps } from './cip-image';

const CipImageView: React.FC<ICipImageViewProps> = props => {
    const { config, id, renderModuleAttributes, moduleClassName, imageSettings, context } = props;

    const src = config.image?.src;
    if (!src || !imageSettings) {
        return null;
    }

    return (
        <figure className={moduleClassName} id={id} {...renderModuleAttributes?.(props)}>
            <Image
                requestContext={context.actionContext.requestContext}
                className='msc_image'
                src={src}
                altText={config.alternativeText}
                gridSettings={context.request.gridSettings!}
                imageSettings={imageSettings}
                loadFailureBehavior='hide'
            />
            {config.caption ? <figcaption className={'cip-image__caption'}>{config.caption}</figcaption> : null}
        </figure>
    );
};

export default CipImageView;
